import React, { FC } from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

interface BackflowSelectDropdownProps {
  value: any;
  label: string;
  onChange: any;
  options: any;
}

const BackflowSelectDropdown: FC<BackflowSelectDropdownProps> = (props) => {
  let { value, label, onChange, options } = props;

  // Convert value to string to ensure it matches option values (which are strings)
  const stringValue = value != null ? String(value) : '';

  return (
    <FormControl fullWidth sx={{ mb: 4 }}>
      <InputLabel>{label}</InputLabel>
      <Select value={stringValue} label={label} onChange={(e) => onChange(e.target.value)}>
        <MenuItem value="">
          <em>Choose {label}...</em>
        </MenuItem>
        {options?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BackflowSelectDropdown;
